import Consumer, { ConsumerObject } from 'consumerjs';


class Address extends ConsumerObject {
    get city() { return this._city; }
    get post_code() { return this._post_code; }
    get country() { return this._country; }
    get addition() { return this._addition; }
    get number() { return this._number; }
    get province() { return this._province; }

    set city(value) { this._city = value; }
    set post_code(value) { this._post_code = value; }
    set country(value) { this._country = value; }
    set number(value) { this._number = value; }
    set addition(value) { this._addition = value; }
    set province(value) { this._province = value; }
}


export class AddressConsumer extends Consumer {
    constructor(endpoint='/api/address/', objectClass=Address) {
        super(endpoint, objectClass);
    }

    getAddressDetails(post_code, number, addition) {
        return this.get('/', {post_code: post_code, number: number, addition: addition});
    }
}



// WEBPACK FOOTER //
// ./src/my_artis/js/data/address/address.js